import { useRouteLocationWithLocale } from '#imports'
import { type MaybeRefOrGetter, computed, toValue } from 'vue'

import type { ArticlePageContent } from '@backmarket/http-api/src/api-specs-content/models/article-page-content'
import type { MappedApiPageContent } from '@backmarket/http-api/src/api-specs-content/models/base-page-content'

import { CMS } from '../../../cms/routes-names'

export function useGetBreadcrumb(
  contentRef: MaybeRefOrGetter<
    MappedApiPageContent<ArticlePageContent> | null | undefined
  >,
) {
  const resolveLocalizedRoute = useRouteLocationWithLocale()

  return computed(() => {
    const content = toValue(contentRef)

    if (!content) {
      return {
        currentPageTitle: '',
        intermediaryPath: [],
      }
    }

    const { categories = [], titleBreadcrumb: currentPageTitle = '' } = content

    const intermediaryPath = categories.map(({ title, slug }) => {
      return {
        title,
        link: resolveLocalizedRoute({
          name: slug === 'content' ? CMS.ARTICLE_ROOT_HUB : CMS.ARTICLE_HUB,
          params: { pageCategory: slug },
        }),
      }
    })

    return {
      currentPageTitle,
      intermediaryPath,
    }
  })
}
